import {Radio} from 'antd';
import {RadioChangeEvent} from 'antd/es/radio';
import React, {
    useMemo, useState, FC,
} from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';

import {resetMetadata, ISubsectionMenu} from 'entities/metadata';
import {resetLoadedData} from 'modules/data';
import {EEntityType} from 'shared/constants/entities';

import './subsection-switcher.less';

export interface ISubsectionSwitcherProps {
    entityName: string;
    location: string;
    subsections: ISubsectionMenu[];
    changeSubsection?: (e: RadioChangeEvent) => void;
    checkedSubsectionValue?: string;
}

export const SubsectionSwitcher: FC<ISubsectionSwitcherProps> = (
    {
        entityName, location, subsections, changeSubsection, checkedSubsectionValue,
    }: ISubsectionSwitcherProps,
) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const defaultValue = checkedSubsectionValue || subsections.find(
        sub => sub.key === location?.replaceAll('/', ''),
    )?.key;
    const [subsection, setSubsection] = useState<string | undefined>(defaultValue);
    const handleSubsectionChange = (e: RadioChangeEvent) => {
        dispatch(resetLoadedData(entityName));
        dispatch(resetMetadata({entityName, entityType: EEntityType.TABLE, loading: true}));
        dispatch(resetMetadata({entityName, entityType: EEntityType.FILTER, loading: true}));
        dispatch(resetMetadata({entityName, entityType: EEntityType.EDITABLE_TABLE, loading: true}));
        if (changeSubsection) {
            changeSubsection(e);
            return;
        }
        setSubsection(e.target.value);
        history.push(e.target.value);
    };
    const sortedSubsections = useMemo(() => subsections.sort(
        (a, b) => (a.order && b.order ? a.order - b.order : 0),
    ), [subsections]);

    return (
        <Radio.Group
            className="subsections"
            value={checkedSubsectionValue || subsection}
            onChange={e => handleSubsectionChange(e)}
        >
            {sortedSubsections.map(sub => (
                <Radio.Button
                    key={sub.key}
                    value={sub.key}
                >
                    {sub.title}
                </Radio.Button>
            ))}
        </Radio.Group>
    );
};
